import { DEFAULTS } from '../video-component';
import ReactPlayer from 'react-player/lazy';
import i18next from 'i18next';
function getUrl(store) {
    const componentData = store.get('componentData');
    return componentData ? componentData.src : '';
}
function updateUrl(src, store) {
    store.update('componentData', {
        src
    });
}
export default {
    config: DEFAULTS.config,
    title: i18next.t('editor.video.modal.title'),
    description: i18next.t('editor.video.modal.input.label'),
    placeholder: i18next.t('editor.video.modal.input.placeholder'),
    errorMessage: i18next.t('editor.video.modal.input.error'),
    validateUrl: ReactPlayer.canPlay,
    getUrl,
    updateUrl,
    inputAlwaysEmpty: true
};
